export default function timeline( container ) {
	if ( ! container ) {
		return false;
	}

	if ( container.dataset.defaultYear ) {
		container.scrollTo( {
			left: document.querySelector( `[data-year="${ container.dataset.defaultYear }"]` ).offsetLeft,
		} );
	}
	container.addEventListener( 'wheel', function( e ) {
		if ( Math.abs( e.deltaX ) > 0 ) {
			return;
		}
		if ( e.deltaY > 0 ) {
			// scrollbehavior:smooth decreases perceived sensitivity for mousewheel hijacking
			if ( container.scrollLeft < ( container.firstElementChild.clientWidth - container.clientWidth ) ) {
				// container.parentElement.scrollIntoView({ behavior: 'smooth' })
				container.scrollLeft += 340;
				e.preventDefault();
			}
		} else if ( container.scrollLeft > 0 ) {
			// container.parentElement.scrollIntoView({ behavior: 'smooth' })
			container.scrollLeft -= 340;
			e.preventDefault();
		}
	} );
// That will work perfectly
}
